import React from 'react'
import Loader from "react-loader-spinner";
// import './Card.css'

export default function Card({SVG ,isLoading, title , cardBackgroundColor,totalUsers,totalDepartments,totalCollections,totalFiles}) {
    function getTotal(){
        let totalItems
        if(title === "Total Files"){
            totalItems = totalFiles
        }
        if(title === "Total Users"){
            totalItems = totalUsers
        }
        if(title === "Departments"){
            totalItems = totalDepartments
        }
        if(title === "Collections"){
            totalItems = totalCollections
        }
        return totalItems
    }
    return (
        <div className="bg-white px-6 py-8 rounded-lg">
            <div className="flex">
                <div className="badge rounded" style={{ backgroundColor:cardBackgroundColor }}>
                  <div className="text-white">
                  {SVG}
                  </div>
                </div>
                <span className="font-semibold  ml-2">{title}</span>
            </div>
            <div className="mt-4">
                {
                               !isLoading &&
                              <span className="font-extrabold text-3xl">
                               {getTotal()}
                           </span>
                           }
                           {
                               isLoading && 
                               <Loader
                                    type="Puff"
                                    color="#F35D2D"
                                    height={40}
                                    className="ml-4"
                                    width={40} />
                           }
            </div>
        </div>
    )
}
